import ErrorMessage from "components/error/error";
import NoData from "components/noData/noData";
import { useProducts } from "hooks/use-products";
import React from "react";
import { Spinner } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import CardProduct from "./component/cardProduct";

const MyProducts = () => {
  const { t } = useTranslation("browse-apps");
  const { products, isLoading, isError, isSuccess } = useProducts();

  return (
    <div className="wishlist myporoducts">
      <div className="header">
        <h1 className="title">{t("myProducts.mainTitle")}</h1>
      </div>
      <hr className="hr" />

      <div className="row">
        {isError && <ErrorMessage />}
        {isLoading && (
          <div className="my-center">
            <Spinner animation="grow" variant="primary" />
          </div>
        )}
        {(isSuccess && products.length > 0) && (
          products.map((pro) => (
            <div className="col-xl-2 col-lg-4 col-md-6" key={pro.versionSubscriptionId}>
              <CardProduct
                logo={pro?.logo?.fullPath}
                name={pro?.versionName}
                appName={pro?.applicationName}
                release={pro?.releaseNumber}
                levelName={pro?.priceLevel}
                date={pro?.renewDate}
                numberOfLicenses={pro?.numberOfLicenses}
                usedDevice={pro?.usedDevice}
                newRelease={pro?.newRelease}
                price={pro?.price}
                url={`/my-apps/${pro?.versionSubscriptionId}`}
              />
            </div>
          ))
        )} 
        {(products.length === 0 && !isLoading) &&(
          <div className="col-12">
            <NoData packages={"products"} withButton />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyProducts;
